import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Img from "react-cool-img";
import Helper from "utils/Helper";

// Components
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

// icons
import StorefrontOutlineIcon from "mdi-react/StorefrontOutlineIcon";
import Logo from "assets/logo/logo.png";
import CreatorPlaceholder from "assets/creator_placeholder.webp";

const useStyles = makeStyles((theme) => ({
	image: {
		width: "100%",
	},
	name: {
		fontSize: 18,
	},
	impression: {
		fontSize: 15,
		color: "grey",
	},
	bottomSection: {
		padding: 12,
		backgroundColor: "#FDF4F8",
		borderRadius: "0 20px 0 0",
	},
	linkName: {
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontSize: 15,
		color: "grey",
	},
	logo: {
		composes: "col-2",
		width: 20,
		verticalAlign: "middle",
		marginRight: 8,
	},
	storeLogo: {
		cursor: "pointer",
		padding: 12,
		color: "grey",
	},
}));

function CreatorCard(props) {
	const classes = useStyles(props);
	const { src = "", name = "", link = "", impression = 0 } = props;

	return (
		<Paper square>
			<Img
				className={classes.image}
				placeholder={CreatorPlaceholder}
				src={src}
				error={CreatorPlaceholder}
				alt={`creator_${name}`}
			/>
			<Box p={2}>
				<div className={classes.name}>{name}</div>
				<div className={classes.impression}>
					{Helper.NumberWithCommas(impression)} Likes
				</div>
			</Box>

			<Grid container>
				<Grid
					item
					xs={9}
					sm={9}
					md={9}
					className={classes.bottomSection}
				>
					<Grid container>
						<Grid item xs={2}>
							<Img
								className={classes.logo}
								placeholder={Logo}
								src={Logo}
								error={Logo}
								alt={`creator_card_logo`}
							/>
						</Grid>
						<Grid item xs={9} className={classes.linkName}>
							<span>@{link}</span>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3} sm={3} md={3} className={classes.storeLogo}>
					<Box display="flex" justifyContent="center">
						<StorefrontOutlineIcon
							onClick={() => {
								window.open(
									`https://creator.memopresso.com/${link}`,
									"_blank"
								);
							}}
						/>
					</Box>
				</Grid>
			</Grid>
		</Paper>
	);
}

export default CreatorCard;
